import {Pipe, PipeTransform} from '@angular/core';
import {Geometry} from '@turf/helpers';

@Pipe({
    name: 'convertPolygon'
})
export class ConvertPolygonPipe implements PipeTransform {

    transform(geo: any, ...args: unknown[]): { lat: number, lng: number }[] {
        return geo.coordinates[0].map(c => {
            return {lat: c[1], lng: c[0]}
        });
    }

}
